import styles from './CategoryFilter.scss';
import { useDispatch } from 'react-redux';
import equal from 'fast-deep-equal/react';
import { t } from '~/utils/localization';
import Tag from '~/components/Tag/Tag';
import { scrollTop } from '~/utils/scrollTop';
import { FilterPosition } from '~/types/category';
import { RootState, useAppSelector } from '~/Store';
import { appActions } from '~/Store/appSlice';

interface IFilterPresets {
    category: ICategoryList;
}

const stateSelector = (state: RootState) => {
    return {
        categories: state.app.categories,
        activePreset: state.app.activePreset,
        filterPosition: state.account.filterPosition,
    };
};

const title = t('Подборки');

const FilterPresets = ({ category }: IFilterPresets) => {
    const dispatch = useDispatch();
    const state = useAppSelector(stateSelector, equal);
    const filtersPresets = state.categories[category]?.filters?.presets;

    return (
        <div className={styles.presetsWrapper}>
            <div
                className={styles.presetsItems}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                {filtersPresets.map((preset) => {
                    const isActive = state.activePreset === preset.name;

                    if (!preset.type && !preset.bundles?.length) {
                        return null;
                    }

                    return (
                        <Tag
                            key={preset.name}
                            label={preset.title}
                            isActive={isActive}
                            showCloseIcon={isActive}
                            onClick={() => {
                                scrollTop(0, state.filterPosition === FilterPosition.RIGHT);
                                dispatch(appActions.updateActiveFilterPreset({ preset: preset.name }));
                            }}
                            classNames={{
                                tag: styles.filterPreset,
                                activeTag: styles.active,
                            }}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default FilterPresets;
